import styled from 'styled-components';
import { getSpace, px2rem, mq, gridContainer, setGridColumns } from '../../../../stylesheets/tools';

const StyledEducationQuickFacts = styled.section`
  padding-bottom: ${getSpace('l')};

  ${mq('m')} {
    padding: ${getSpace('xl')} 0;
  }
  .quick-facts__grid {
    gap: ${px2rem('20px')};
    ${gridContainer()}

    ${mq('m')} {
      gap: ${px2rem('30px')};
      ${setGridColumns('1fr', 2)}
    }
    ${mq('xl')} {
      ${setGridColumns('1fr', 4)}
    }
  }
`;

export default StyledEducationQuickFacts;
